// bao migrate skip
import TabPage from "./../../factories/tab-page";
import baoRouter from "./../../services/bao-router";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItemReminderTab {
    private _subs: KnockoutSubscription[] = [];
    Bao = Bao;
    PageIndex = ko.observable<number>(0);
    PageSize = ko.observable<number>(20);
    TotalRows = ko.observable<number>(0);
    Sorting = ko.observable<any>();
    ReminderCollection = ko.observableArray<any>();
    ShowCompletedReminders = ko.observable<boolean>(false);
    Loading = ko.observable<boolean>(false);
    SelectedReminderRow = ko.observable<any>();
    SelectionReminderRows = ko.observableArray<any>([]);
    constructor(public TabPage: TabPage, public Parent) {
        this._subs.push(this.PageIndex.subscribe(() => {
            if (this.Loading() == false) {
                this.Refresh();
            }
        }));
        this._subs.push(this.Sorting.subscribe(() => {
            if (this.Loading() == false) {
                this.Refresh();
            }
        }));
        this._subs.push(this.ShowCompletedReminders.subscribe(() => {
            if (this.Loading() == false) {
                this.PageIndex(0);
                this.Refresh();
            }
        }));
        this.SelectionReminderRows.subscribe((newValue) => this.SelectionChanged(newValue));
    }
    public SelectionChanged(selectedRows: any[]): JQueryXHR {
        this.EnableDisableButtons(selectedRows);
        if (selectedRows != null && selectedRows.length == 1) {
            this.SelectedReminderRow(selectedRows[0]);
        }
        else {
            this.SelectedReminderRow(null);
        }
        return null;
    }
    EnableDisableButtons(selectedRows: any[]) {
        if (selectedRows != null && selectedRows.length > 0) {
            if (selectedRows.length == 1) {
                this.enableDisableButton("ConfigurationItemReminderEdit", true);
            }
            else {
                this.enableDisableButton("ConfigurationItemReminderEdit", false);
            }
            this.enableDisableButton("ConfigurationItemReminderDelete", true);
        }
        else {
            this.enableDisableButton("ConfigurationItemReminderEdit", false);
            this.enableDisableButton("ConfigurationItemReminderDelete", false);
        }
    }
    enableDisableButton = (ActionKey: string, Enabled: boolean) => {
    };
    AddReminder = () => {
        baoRouter.setHash("#reminder/new/" + ko.unwrap(this.Parent.ConfigurationItemId));
    };
    EditConfigurationItemReminder = (item) => {
        if (item != null) {
            baoRouter.setHash("#reminder/" + ko.unwrap(item.ConfigurationItemReminderId));
        }
    };
    DeleteConfigurationItemReminder = (item) => {
        if (item != null) {
            var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteConfigurationItemReminder"), "yesno");
            questionDialog.DialogResult.subscribe((result) => {
                if (result === true) {
                    this.TabPage.IsLoading(true);
                    Bao.post("reminder/Delete", JSON.stringify({
                        id: item.ConfigurationItemReminderId,
                    }), (result) => {
                        this.TabPage.IsLoading(false);
                        this.Refresh();
                    });
                }
            });
        }
    };
    toolbarClick = (item) => {
        switch (item.ActionKey()) {
            case "ConfigurationItemReminderAdd":
                this.AddReminder();
                break;
            case "ConfigurationItemReminderEdit":
                this.EditConfigurationItemReminder(this.SelectedReminderRow());
                break;
            case "ConfigurationItemReminderTabRefresh":
                this.Refresh();
                break;
            case "ConfigurationItemReminderDelete":
                this.DeleteConfigurationItemReminder(this.SelectedReminderRow());
                break;
        }
    };
    CompleteCheck() {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    }
    Refresh() {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemReminderTab/Get", JSON.stringify({
            configurationItemId: this.Parent.ConfigurationItemId(),
            showCompleted: this.ShowCompletedReminders(),
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result) => {
            this.TabPage.IsLoading(false);
            this.TotalRows(result.TotalRows);
            this.ReminderCollection(result.Models);
            this.SelectionReminderRows([]);
            this.Loading(false);
        });
    }
    init() {
    }
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ConfigurationItemReminderTab;